import { ISiteWalkMedia, ISiteWalkMediaLevel } from '@api/models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllFloorPlansGui = async (clientId: string, projectId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/site-walk-media`
    );

    return data as ISiteWalkMedia;
};

export const updatePolygonInSiteWalk = async (
    clientId: string,
    projectId: string,

    siteWalkMediaId: string,
    payload: ISiteWalkMediaLevel[]
) => {
    const { data } = await http.patch(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/site-walk-media/${siteWalkMediaId}/coordinates`,
        { levels: payload }
    );

    return data as ISiteWalkMedia;
};

export const uploadFileInSiteWalk = async (
    clientId: string,
    projectId: string,

    siteWalkMediaId: string,
    payload: any
) => {
    //     Body should have a file
    // {mediaType:"IMAGE"}
    const { data } = await http.patch(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/site-walk-media/${siteWalkMediaId}/background-image`,
        payload
    );

    return data as ISiteWalkMedia;
};
export const createFloorPlansGui = async (
    clientId: string,
    projectId: string,

    payload: any
) => {
    const { data } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/site-walk-media`,
        payload
    );

    return data as ISiteWalkMedia;
};
